import React, { memo, useEffect } from 'react'
import { Row, Container } from '@paypalcorp/pp-react'
import Spinner from '../../../../screens/dsr/common/dsr-spinner'
import { LOGGEDOUT_VERIFICATION_API } from '../../../../constants/constants'
import { post } from '../../../../utils/ajax.js'
import { serverData } from '../../../../utils'

const useQuery = (queryParam) => {
  const search = new URLSearchParams(document.location.search)
  return search.get(queryParam)
}
const EmailVerification = memo((props) => {
  const token = useQuery('token')
  const caseid = useQuery('caseid')

  useEffect(() => {
    const reqparams = {
      _csrf: serverData._csrf,
      verificationToken: token || '',
      requestid: caseid || '',
    }

    async function postVerificationRequest() {
      const response = await post(LOGGEDOUT_VERIFICATION_API, reqparams)
      if (response && response.success) {
        const { data = {} } = response
        props.changeState(true, data)
      } else {
        props.changeState(false)
      }
    }
    postVerificationRequest()
  }, [])

  return (
    <Container form>
      <Row>
        <Spinner />
      </Row>
    </Container>
  )
})
EmailVerification.displayName = 'EmailVerification'

export default EmailVerification
